import React, { useState } from 'react';
import { WizardAction, WizardRootItem } from '../Interfaces/Wizard.interface';
import Wizard, { WizardJobWaitingSetup } from './Wizard';
import BaseModal, {
	BaseModalProps,
} from '../../Base/Components/BaseModal/BaseModal';

interface Props extends BaseModalProps {
	title: string;
	wizardKey: string;
	initialData?: object;
	keepInitialData?: boolean;
	jobWaitingSetup?: WizardJobWaitingSetup;
	onWizardDone: (action?: WizardAction) => void;
}

const WizardModal: React.FC<Props> = props => {
	const [activeStep, setActiveStep] = useState<WizardRootItem | null>(null);

	return (
		<BaseModal {...props} hideClose={activeStep?.settings?.hideClose}>
			<Wizard {...props} onActiveStepChange={setActiveStep} />
		</BaseModal>
	);
};

export default WizardModal;
